const TRUNCATE_UNITS = Object.freeze({
  STRING: 'string',
  ARRAY: 'array',
});

export default TRUNCATE_UNITS;
